import React from "react";
import "./ContactMe.css";

const ContactMe = () => {
  return (
    <section className="contact-card" aria-labelledby="contact-heading">
      <h2 id="contact-heading" className="contact-title">
        Contact Information
      </h2>

      <div className="contact-grid">
        {/* Email */}
        <div className="contact-item">
          <div className="icon-wrapper icon-email" aria-hidden="true">
            <i className="fas fa-envelope"></i>
          </div>
          <div className="contact-body">
            <span className="contact-label">Email</span>
            <a
              className="contact-value"
              href="mailto:danaraga@ra-engineering-services.com"
            >
              danaraga@ra-engineering-services.com
            </a>
          </div>
        </div>

        {/* Phone */}
        <div className="contact-item">
          <div className="icon-wrapper icon-phone" aria-hidden="true">
            <i className="fa fa-phone"></i>
          </div>
          <div className="contact-body">
            <span className="contact-label">Phone</span>
            <a className="contact-value" href="tel:+639178734013">
              (+63) 917 873 4013
            </a>
          </div>
        </div>

        {/* Location */}
        <div className="contact-item">
          <div className="icon-wrapper icon-location" aria-hidden="true">
            <i className="fa fa-map-marker"></i>
          </div>
          <div className="contact-body">
            <span className="contact-label">Location</span>
            <a
              href="https://maps.app.goo.gl/eKiXBZEUmrbrffBH9"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="contact-value">
                495 M. Naval St, Navotas, 1478 Metro Manila
              </span>
            </a>
          </div>
        </div>
        <div className="contact-item">
          <div className="icon-wrapper icon-email" aria-hidden="true">
            <i className="fa fa-clock"></i>
          </div>
          <div className="contact-body">
            <span className="contact-label">Operating Hours</span>
            <span className="contact-value">8:00 AM - 5:00 PM (Mon - Sat)</span>
          </div>
        </div>
        <div className="contact-item">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3860.1341817092793!2d120.94856347599885!3d14.648323585843684!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3397b5d5f7a18805%3A0x6ac9e48fedae4ab2!2sR.A.%20Engineering%20Services!5e0!3m2!1sen!2sph!4v1765285164799!5m2!1sen!2sph"
            style={{
              border: 0,
              width: "100%",
              height: "auto",
              justifyContent: "center",
              borderRadius: "10px",
            }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="RA Engineering Services Location"
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default ContactMe;
